import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=fe9fe0b8&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fe9fe0b8')) {
      api.createRecord('fe9fe0b8', component.options)
    } else {
      api.reload('fe9fe0b8', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=fe9fe0b8&", function () {
      api.rerender('fe9fe0b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2dQSqeLsbEXzu/JS/offershelp.vue"
export default component.exports